module.exports = __webpack_public_path__ + "src/assets/img/logo_w.bec324a9.png";